import  * as component  from './components'
export default [
    {
      name: 'report.campaignsnew',
      path: '/report/campaignsnew',
      component: component.ReportingNew,
      meta: { requiresAuth: true },
    },
    {
      name: 'report.campaigns',
      path: '/report/campaigns',
      component: component.ReportingsNew
     },
     {
      name: 'report.allcampaigns',
      path: '/report/allcampaigns',
      component: component.ReportingsNew
     },
     {
      name: 'report.allannouncements',
      path: '/report/allannouncements',
      component: component.ReportingsNew
     },
     {
      name: 'report.campaigns.new',
      path: '/report/campaigns/new',
      component: component.ReportingsNew
     },
     {
      name: 'report.repeatAffender',
      path: '/report/repeatAffender',
      component: component.RepeatAffender
     },
     {
      name: 'report.campaignreporting',
      path: '/report/campaigns/:id',
      component: component.campaignReportingNew
     },
     {
      name: 'report.comparereporting',
      path: '/report/compare/:id',
      component: component.compareReportingNew
      },
      {
      name: 'report.campaignreporting.new',
      path: '/report/campaigns/new/:id',
      component: component.campaignReportingNew
     },
     {
      name: 'report.campaignfiledreports',
      path: '/report/campaigns/failed/:id',
      component: component.campaignFiledReports
     },
     {
      name: 'report.recipientlisting',
      path: '/report/campaigns/:id/:type',
      component: component.recipientListing
     },
     {
      name: 'report.recipientlistinglogs',
      path: '/report/campaigns/logs/:id/:type',
      component: component.recipientListingLogs
     },
     {
      name: 'report.detailedreporting',
      path: '/report/detailed',
      component: component.campaignDetailedReporting
     },
     {
        name: 'report.hcsa',
        path: '/report/hcsa_hisp',
        component: component.hcsa
     },
     {
      name: 'report.campaignreportingScenario',
      path: '/scenarioreport/campaigns',
      component: component.campaignReportingScenario
     },
    {
      name: 'reports.announcementcampaignsperformance',
      path: '/reports/announcementcampaignsperformance',
      component: component.AnnouncementCampaignsPerformance
    },
    {
      name: 'reports.policyannouncementperformance',
      path: '/reports/policyannouncementperformance',
      component: component.PolicyCampaignsPerformance
    },
    {
      name: 'reports.phishingcampaignsperformance',
      path: '/reports/phishingcampaignsperformance',
      component: component.PhishingCampaignsPerformance
    },
    {
      name: 'report.campaigns-detailed-report',
      path: '/reports/campaigns-detailed-report',
      component: component.campaignsDetailedReport
    },
    {
      name: 'report.reports',
      path: '/reports',
      component: component.SavedReports
    },
    {
      name: 'report.UserActivity',
      path: '/reports/UserActivity',
      component: component.UserActivityReports
    },
    {
      name: 'report.exported_files',
      path: '/exported-files',
      component: component.exportedFiles
    },
    {
      name: 'report.view_log',
      path: '/reports/phishing-campaign/view-log/:id',
      component: component.ViewLog
    },
    {
      name: 'report.userportaltraffic',
      path: '/reports/portal-logins',
      component: component.UserPortalTraffic
    }



]



// WEBPACK FOOTER //
// ./src/app/report/routes/index.js